<div class="modal-header">
	<button class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">
	{{#if isNew}}
		{{TR "Neues Lesezeichen"}}
	{{else}}
		{{TR "Lesezeichen"}}: {{name}}
	{{/if}}
	</h4>
</div>
<div class="modal-body">
	{{#if nameIsDuplicate}}
		{{> ALERT info}}
	{{/if}}
	<div class="form-group">
		<label for="js-name-input" >{{TR "Name"}}</label>
		<input id="js-name-input" class="form-control"
			type="text"
			value="{{name}}"
			name="bookmark_name">
		<label for="js-description-input" class="m-t-15" >{{TR "Beschreibung"}}</label>
		<textarea id="js-description-input" maxlength="500" class="form-control">{{description}}</textarea>
		{{#if userCanEditPublic}}
		<div class="checkbox checkbox-primary m-t-15">
			<input
			id="js-public-input"
			name="bookmark-public"
			type="checkbox"
			{{#if public}}checked="checked"{{/if}}>
			<label for="js-public-input">{{TR "Öffentlich"}}</label>
		</div>
		{{/if}}
	</div>
</div>
<div class="modal-footer">
	{{#unless isNew}}
	<button id="js-delete" class="btn btn-white pull-left">{{TR "Löschen"}}</button>
	{{/unless}}
	<button id="ct-cancel" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<button class="btn btn-primary" id="js-save">{{saveButtonName}} </button>
</div>
